import styled from 'styled-components';

import colors from 'styles/theme/colors';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  color?: 'green' | 'red';
}

export default function Badge(props: Props) {
  const { color, ...rest } = props;

  return <ColoredBadge data-cy='badge' color={color} {...rest} />;
}

function getColors(color: Props['color'] = 'green') {
  const colorMap = {
    green: {
      backgroundColor: colors.green10,
      color: colors.green100,
    },
    red: {
      backgroundColor: colors.red10,
      color: colors.red100,
    },
  };

  return colorMap[color];
}

const ColoredBadge = styled.span<{ color: Props['color'] }>`
  padding: 2px 12px;
  box-sizing: border-box;
  border-radius: 24px;
  color: ${({ color }) => getColors(color).color};
  background-color: ${({ color }) => getColors(color).backgroundColor};
  font-size: 10px;
`;
